Jelly.Connections.URL_Import = function(Parameters) {
	// Parameters: Namespace, Input_Namespace, Event_Data

	var Namespace = Parameters.Input_Namespace;
	var Event_Data = Parameters.Event_Data;
	var $Form = $("#" + Namespace);

	// Name
	if (Event_Data.name) {
		Jelly.Actions.Set_Input_Value({
			Namespace: Namespace,
			Alias: "Event_Name",
			Value: Event_Data.name
		});
	}

	// Location - combine venue and address
	var Location_Parts = [];
	if (Event_Data.location_venue) {
		Location_Parts.push(Event_Data.location_venue);
	}
	if (Event_Data.location_address) {
		Location_Parts.push(Event_Data.location_address);
	}
	if (Location_Parts.length) {
		Jelly.Actions.Set_Input_Value({
			Namespace: Namespace,
			Alias: "Location_Address",
			Value: Location_Parts.join(", ")
		});
	}

	// Description - Design Editor needs special handling
	if (Event_Data.description) {
		Jelly.Actions.Set_Input_Value({
			Namespace: Namespace,
			Alias: "Description",
			Value: Event_Data.description
		});
		// Trigger change event for React Design Editor to pick up
		var $descInput = $Form.find("input[name='Description']");
		if ($descInput.length) {
			$descInput.trigger("change");
		}
	}

	// Start Time - set on first ticket
	if (Event_Data.date_time) {
		Jelly.Actions.Set_Input_Value({
			Namespace: Namespace,
			Alias: "New_Tier_1_Start_Time",
			Value: Event_Data.date_time
		});
	}

	// Price - set on first ticket if available
	if (Event_Data.price !== undefined && Event_Data.price !== null && Event_Data.price !== "") {
		var price = parseFloat(Event_Data.price);
		if (!isNaN(price)) {
			Jelly.Actions.Set_Input_Value({
				Namespace: Namespace,
				Alias: "New_Tier_1_Price",
				Value: price
			});
			// Set ticket kind based on price
			if (price === 0) {
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "New_Tier_1_Kind",
					Value: "Free"
				});
			}
		}
	}

	// Cover image - upload via Uploadcare
	if (Event_Data.cover_url) {
		Jelly.Actions.Set_Input_Value({
			Namespace: Namespace,
			Alias: "Cover",
			Value: Event_Data.cover_url
		});
	}

	// Set published to true by default
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Published",
		Value: true
	});

	// Close the import modal
	Jelly.Interface.Close_Top_Window();
};
